module.exports = __webpack_public_path__ + "img/IR.f6eb0772.svg";